export default __webpack_public_path__ + "static/media/start.c91abefb.svg";